import React, { Component } from 'react';
import { Modal, message, Button, Input, Popover } from 'antd';
import genOperationAuth from '../../common/genOperationAuth';
import TableC from '../../basicElement/TableC';
import LookAttachment from './LookAttachment';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import format from '../../shared/format';
import SideNav from '../SideNav';
import Update from './Update';

class ChildContract extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        loading: false,
        pagination: {
            pageSize: 11,
            current: 1,
        },
        mainJdeCode: '',
    }

    componentDidMount() {
        this.getMainJde();
        this.loadData();
    }

    getMainJde = () => {
        const options = {
            url: API_URL.investigation.queryInvJde,
            data: {},
            dataType: 'json',
            doneResult: data => {
                if (data.data.jdeCode) {
                    this.setState({
                        mainJdeCode: data.data.jdeCode
                    });
                }
            },
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            url: API_URL.investigation.listChildrenJde,
            data: {
                offset: current,
                limit: pageSize - 1,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { totalCount, datas } = res;
                pagination.total = totalCount + Math.ceil(totalCount / (pageSize - 1));
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    // 关闭申请审批流程中的JDE建号申请所在项目下，不可再添加新的子合同记录
    inJdeApplyCloseProgress = (record, type) => {
        const { invId:investigationId } = sessionStorage || {};
        const options = {
            url: API_URL.investigation.inJdeApplyCloseProgress,
            data: {
                investigationId
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res || {};
                if(data) {
                   message.warning('本项目已经在走关闭流程，不可添加新合同');
                }
                else{
                    this.updateRef.show(record, type);
                }
               
            },
            errorResult: () => {
               
            },
        };
        $.sendRequest(options);
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination
        }, () => {
            this.loadData();
        });
    }

    delete = (jdeCodeId) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: '确定要删除吗？',
            onOk: () => {
                this.setState({ loading: true });
                $.sendRequest({
                    url: API_URL.investigation.deleteChildrenJde,
                    data: { jdeCodeId },
                    dataType: 'json',
                    doneResult: () => {
                        message.success("删除成功");
                        this.setState({ loading: false }, () => {
                            this.loadData();
                        });
                    },
                    errorResult: () => {
                        this.setState({ loading: false });
                    }
                });
            }
        });
    }

    getColumns = () => {
        const { curRole } = sessionStorage;

        const columns = [{
            title: '序号',
            dataIndex: 'number',
            key: 'number',
            width: 60,
            fixed: 'left',
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'jdeCode',
            width: 100,
            fixed: 'left',
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '合同签署单位',
            dataIndex: 'signingUnit',
            key: 'signingUnit',
            width: 100,
        }, {
            title: '收入归属单位',
            dataIndex: 'belongingToUnit',
            key: 'belongingToUnit',
            width: 100,
        }, {
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 100,
        }, {
            title: '客户JDE号',
            dataIndex: 'customerJdeCode',
            key: 'customerJdeCode',
            width: 100,
        }, {
            title: '名称(ProjectID)',
            dataIndex: 'projectIdName',
            key: 'projectIdName',
            width: 120,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 120,
        }, {
            title: '发票税率',
            dataIndex: 'invoiceRate',
            key: 'invoiceRate',
            width: 80,
            render: (text) => format('unit', text, '%'),
        }, {
            title: '是否据实结算',
            dataIndex: 'isRealitySettle',
            key: 'isRealitySettle',
            width: 100,
            render:text => text==1?'是':text==0?'否':''
        },{
            title: '客户是否MSA特殊优惠客户',
            dataIndex: 'isMsaSpecialDiscountCustom',
            key: 'isMsaSpecialDiscountCustom',
            width: 100,
            render: (text , row) => {
                const { isDiscountTermValidity } = row;
                return isDiscountTermValidity == 1?'是':text==1?'是':text==0?'否':'';
            },
        },{
            title: '是否在优惠有效期内',
            dataIndex: 'isDiscountTermValidity',
            key: 'isDiscountTermValidity',
            width: 100,
            render:text => text==1?'是':text==0?'否':''
        },{
            title: 'MSA特殊优惠是否从合同额中扣减',
            dataIndex: 'isMsaSpecialContractReduce',
            key: 'isMsaSpecialContractReduce',
            width: 100,
            render:text => text==1?'是':text==0?'否':''
        },{
            title: '优惠金额（含税）/人民币',
            dataIndex: 'discountContractAmount',
            key: 'discountContractAmount',
            width: 100,
        },{
            title: '优惠金额（不含税）/人民币',
            dataIndex: 'discountContractAmountNoTax',
            key: 'discountContractAmountNoTax',
            width: 100,
        },{
            title: '合同是否签署完成',
            dataIndex: 'investigationJdeContractIsSigned',
            key: 'investigationJdeContractIsSigned',
            width: 80,
            render: text => text ? text === "1" ? "是" : "否" : '',
        }, {
            title: '合同中是否明标合同金额',
            dataIndex: 'investigationJdeContractIsSpecifiesAmount',
            key: 'investigationJdeContractIsSpecifiesAmount',
            width: 100,
            render: text => text ? text === "1" ? "是" : "否" : '',
        }, {
            title: '币种',
            dataIndex: 'currency',
            key: 'currency',
            width: 100,
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 80,
        }, {
            title: '预计合同金额/原币',
            dataIndex: 'expectInitialContractAmount',
            key: 'expectInitialContractAmount',
            width: 140,
            render: text => format('money', text),
        }, {
            title: <span>预计合同金额<br/>/人民币(元)</span>,
            dataIndex: 'expectCnyContractAmount',
            key: 'expectCnyContractAmount',
            width: 140,
            render: text => format('money', text),
        }, {
            title: '合同额含税/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 140,
            render: (text, record) => {
                const { initialActualExpenseFee, initialTaxationFee, initialActualFee } = record;
                if (initialActualExpenseFee != undefined || initialActualFee != undefined || initialTaxationFee != undefined) {
                    return (
                        <Popover
                            placement="right"
                            overlayClassName="gray-pop"
                            content={<div>
                                {(initialActualExpenseFee != undefined) && <p>{`实报实销(不含税)/原币: ${format('money', initialActualExpenseFee)}`}</p>}
                                {(initialActualFee != undefined) && <p>{`实报实销税费/原币: ${format('money', initialActualFee)}`}</p>}
                                {(initialTaxationFee != undefined) && <p>{`合同额税费/原币: ${format('money', initialTaxationFee)}`}</p>}
                            </div>}
                            trigger="hover"
                        >
                            <div>
                                <i className='pop' style={{cursor: 'pointer'}}></i>
                                {format('money', text)}
                            </div>
                        </Popover>
                    );
                } else {
                    return format('money', text);
                }
            },
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'jdeContractAmountShow',
            key: 'jdeContractAmountShow',
            width: 140,
            render: (text, record, row) => {
                const { actualExpenseFeeShow, taxationFeeShow, actualFeeShow } = record;
                if (actualExpenseFeeShow != undefined || taxationFeeShow != undefined || actualFeeShow != undefined) {
                    return (
                        <div>
                            <Popover
                                placement="bottomLeft"
                                overlayClassName="contract-pop"
                                content={<div>
                                    {(actualExpenseFeeShow != undefined)? <p>{`实报实销(不含税)/人民币: ${format('money', actualExpenseFeeShow)}`}</p> : null}
                                    {(actualFeeShow != undefined)? <p>{`实报实销税费/人民币: ${format('money', actualFeeShow)}`}</p> : null}
                                    {(taxationFeeShow != undefined) ? <p>{`合同额税费/人民币: ${format('money', taxationFeeShow)}`}</p> : null}
                                </div>}
                                trigger="hover"
                            >
                                <i className='pop' style={{ cursor: 'pointer' }}></i>
                            </Popover>
                            <div className='pop-div'>{format('money', text)}</div>
                        </div>
                    )
                } else {
                    return <div className='pop-div'>{format('money', text)}</div>
                }
            }
        }, {
            title: '合同税率',
            dataIndex: 'rate',
            key: 'rate',
            width: 80,
            render: text => format('unit', text, '%'),
        }, {
            title: '合同新增时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 100,
            render: value => format('date', value),
        }, {
            title: '合同开始时间',
            dataIndex: 'startTimeShow',
            key: 'startTimeShow',
            width: 100,
        }, {
            title: '合同结束时间',
            dataIndex: 'endTimeShow',
            key: 'endTimeShow',
            width: 100,
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 80,
        }, {
            title: '关联JDE',
            dataIndex: 'relationContractCode',
            key: 'relationContractCode',
            width: 100,
        }, {
            title: '备注',
            dataIndex: 'comments',
            key: 'comments',
            width: 140,
        }, {
            title: '操作',
            width: 120,
            fixed: 'right',
            render: (text, record) => {
                const { isContrary, investigationJdeContractId, jdeApplyId } = record;
                const isNegativeContract = isContrary == 1;
                const jdeContractExist = investigationJdeContractId > 0;

                const operationCorrespondRoles = new Map([
                    ['edit', {
                        name: '修改',
                        display: jdeContractExist,
                        editable: !isNegativeContract,
                        event: () => this.update(record, 'edit'),
                        roles: ['CTA'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: jdeContractExist && !jdeApplyId,
                        editable: !isNegativeContract,
                        event: () => this.delete(investigationJdeContractId),
                        roles: ['CTA'],
                    }],
                    ['attachment', {
                        name: '查看附件',
                        display: jdeContractExist,
                        editable: !isNegativeContract,
                        event: () => this.showAttachment(record),
                        roles: ['*'],
                    }]
                ]);
                return genOperationAuth(operationCorrespondRoles, curRole);
            },
        }];
        return columns;
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = data.map((item, index) => {
            if (item.investigationJdeContractId < 0) {
                return ({
                    number: "合计",
                    jdeContractAmountShow: item.jdeContractAmountShow,
                });
            } else {
                return ({
                    number: (current - 1) * (pageSize - 1) + index + 1,
                    ...item,
                });
            }
        });
        return dataSource;
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    handleTableChange = (params) => {
        this.setState({
           ...params,
        }, () => {
            this.loadData();
        });
    }

    update = (record, type) => {
        if(type == 'add'){
            this.inJdeApplyCloseProgress(record, type);
        }
        else{
            this.updateRef.show(record, type);
        }
        
    }

    showAttachment = record => {
        this.showAttachmentModal.show(record);
    }

    render() {
        const { curRole } = sessionStorage;
        const {
            loading,
            pagination,
            mainJdeCode,
            searchParams,
        } = this.state;
        const isCTA = curRole == 'CTA';
        return (
            <div className="content invcontractchild">
                <SideNav selectKey="childContract" />
                <div className="main" style={{ minHeight: "400px" }}>
                    <div className="filter-bar bar2">
                        <div className="form-item">
                            <label htmlFor="" className="ui-label">JDE项目号</label>
                            <Input
                                placeholder="请输入"
                                value={searchParams.jdeCode}
                                onKeyPress={this.enterSearch}
                                onChange={e => this.handleChange(e.target.value, 'jdeCode')}
                            />
                        </div>
                        <div className="btn" style={{ float: 'right' }}>
                            {
                                isCTA &&
                                <Button type="primary" onClick={() => this.update({}, 'add')}>添加</Button>
                            }
                            <Button type="primary" onClick={this.search}>搜索</Button>
                        </div>
                    </div>
                    <TableC
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        loading={loading}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <LookAttachment ref={el => this.showAttachmentModal = el} />
                </div>
                <Update
                    ref={el => this.updateRef = el}
                    reload={this.loadData}
                    mainJdeCode={mainJdeCode}
                />
            </div>
        );
    }
}

export default ChildContract;


// WEBPACK FOOTER //
// ./src/components/projectContract/childContract/index.js